import React, { useState } from "react";
import StatusContext from "../../../contexts/StatusContext";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

export const CardStripePaymentForm = ({ clientSecret, price, onSuccess, onCancel }) => {

  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  let {
    isMobile,
    changeLanguage,
  } = React.useContext(StatusContext);


  const handleSubmit = async (event) => {

    event.preventDefault();

    console.log("CardStripePaymentForm: handleSubmit");

    if (!stripe || !elements) {
      console.log("Stripe or Elements not ready");
      return;
    }

    setLoading(true);
    setErrorMessage("");

    try {

      // Validate the Payment Element
      const { error: submitError } = await elements.submit();

  
      if (submitError) {
        setErrorMessage(submitError.message);
        setLoading(false);
        return;
      }

      // ---------------------------------------------
      // Confirm payment
      // ---------------------------------------------
      const { error } = await stripe.confirmPayment({
        elements,
        clientSecret,

        
        confirmParams: {
          return_url: window.location.origin + "/payment-complete",
        },

        // Don't redirect unless Stripe actually requires it
        redirect: "if_required",
      });


      if (error) {
        console.log(
          "Stripe payment failed", error.message
        );

        setErrorMessage(error.message || "Payment failed.");
        setLoading(false);

        if (onCancel) { onCancel(error); }
        return;
      }

      // ---------------------------------------------
      // Payment successful
      // ---------------------------------------------

      console.log(
        "Stripe payment successful"
      );

        if (onSuccess) { 
            onSuccess(); 
        } 

    
    } catch (error) { 
      console.error( "Unexpected payment error:", error ); 
      setErrorMessage( error.message || "Payment failed." ); 
    } 
    finally { 
      setLoading(false); }
  };


  return (
    <form onSubmit={handleSubmit}>

    {/* ----------------------------------------- */}
    {/* STRIPE PAYMENT ELEMENT                    */}
    {/* ----------------------------------------- */}

      <div style={{
        backgroundColor: "white",
        padding: "15px",
        borderRadius: "8px",
        marginTop: "10px"
      }}>
     
        <PaymentElement />

         
      </div>

    {/* ----------------------------------------- */}
    {/* ERROR                                     */}
    {/* ----------------------------------------- */}

      {errorMessage && (
        <div style={{
          color: "red",
          marginTop: "10px",
          fontSize: "14px"
        }}>
          {errorMessage}
        </div>
      )}

    {/* ----------------------------------------- */}
    {/* BUTTONS                                   */}
    {/* ----------------------------------------- */}
      <div>
        
        <label style={{
              color: "maroon",
              fontWeight: "500",
              fontSize: !isMobile() ? "20px" : "16px",
              display: "block",
              textAlign: "center",
            }}>
            {`Cena: $${Number(price ?? 0).toFixed(2)}`}
        </label>
       
      </div>

      <div style={{
        display: "flex",
        justifyContent: "center",
        gap: "10px",
        marginTop: "15px"
      }}>
       
        <button
          type="submit"
          disabled={!stripe || !elements || loading}
          style={{
            padding: "10px 25px",
            backgroundColor: "#8a3939",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: loading ? "default" : "pointer"
          }}
        >
          {loading ? "Processing..." : changeLanguage('credits','paynow')}
        </button>

        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          style={{
            padding: "10px 20px",
            backgroundColor: "lightgray",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer"
          }}
        >
          {changeLanguage('credits', 'cancelpayment')}
        </button>

      </div>

    </form>
  );
};

export default CardStripePaymentForm;